import CookieService from "./CookieService";
import possuiValor from "../components/operator/Utils";
import { http } from "./http";

/**
 * `secure` só em https: em http://localhost o browser descarta o cookie e o
 * desenvolvimento pararia de logar.
 */
export function cookieOptions() {
  let date = new Date();
  date.setTime(date.getTime() + 8 * 3600000);
  return {
    path: "/",
    expires: date,
    secure: window.location.protocol === "https:",
    sameSite: "strict",
  };
}

/**
 * Reduz o objeto user para caber no cookie (limite ~4KB do browser).
 * As telas só usam name/email e user_access[].name/allow_edit.
 */
export function slimUser(user) {
  if (!user) return user;
  return {
    id: user.id,
    name: user.name,
    email: user.email,
    // `checked` é lido por Bots, Parâmetros, Usuários e Preferências para liberar edição
    // (e, em Preferências, a própria visualização). Sem ele o find falha e todo usuário
    // não-admin perde acesso a essas telas.
    user_access: (user.user_access || []).map((a) => ({ name: a.name, checked: a.checked, allow_edit: a.allow_edit })),
  };
}

const AuthService = () => {
  const isLoggedIn = () => {
    return possuiValor(CookieService.get("user"));
  };

  /**
   * Fluxo Azure AD: após o MSAL autenticar, carregamos o usuário + permissões
   * por e-mail no /sessions (o api_token já é o access token do Azure).
   */
  const login = (userName) => {
    var data = { email: userName };
    return new Promise((resolve, reject) => {
      http
        .post("sessions", data)
        .then(function (result) {
          let user = result?.data?.user;
          CookieService.set("user", JSON.stringify(slimUser(user)), cookieOptions());
          resolve(result);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  };

  return {
    isLoggedIn,
    login,
  };
};

export default AuthService();
